import { render, staticRenderFns } from "./history-transfer.vue?vue&type=template&id=28f9baf8&scoped=true&"
import script from "./history-transfer.vue?vue&type=script&lang=js&"
export * from "./history-transfer.vue?vue&type=script&lang=js&"
import style0 from "./history-transfer.vue?vue&type=style&index=0&id=28f9baf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f9baf8",
  null
  
)

export default component.exports